import Modal from './accessibility';
import Dom from '../Utility/Dom';
$(document).ready(() => {
  const eventSidebar = $('#eventSeriesSidebar');
  const body = $('body');
  const header = $('#header');
  const hero = $('.section__hero');

  if(eventSidebar.length){
    body.addClass('hasEventSeriesSidebar');

    // alter share buttons to include the proper url
    const facebookLink = $('.ssba_facebook_share');
    facebookLink.attr('href', 'http://www.facebook.com/sharer.php?u='+window.location.href);

    const twitterLink = $('.ssba_twitter_share');
    const twitterURL = twitterLink.attr('href');
    const newTwitterURL = twitterURL.replace(/(url=).+(&text=)/g, 'url='+window.location.href+'&text=');
    twitterLink.attr('href', newTwitterURL);

    const linkedIn = $('.ssba_linkedin_share ssba_share_link');
    linkedIn.attr('href', 'http://www.linkedin.com/shareArticle?mini=true&url='+window.location.href);
  }

  $('.eventsSidebarOpen').on('click', ()=>{
    body.addClass('eventSidebarOpen');
    header.removeClass('activeHeader activeHeader__fill').css('pointer-events','none');
    $(window).trigger('resize'); // fixes hero sizing when scrollbar disappears.
  });

  $('.series-aside__inner .mobile_close').on('click', ()=>{
    body.removeClass('eventSidebarOpen');
    header.removeClass('activeHeader activeHeader__fill').css('pointer-events','');
    $(window).trigger('resize'); // fixes hero sizing when scrollbar disappears.
  });

  const setSidebarSettings = ()=>{
    const windowWidth = window.innerWidth;

    if(windowWidth >= 991){
      eventSidebar.attr('aria-hidden', 'false');
      eventSidebar.removeClass('active');
    }
    else if(!eventSidebar.hasClass('active')){
      eventSidebar.attr('aria-hidden','true');
    }
  }
  setSidebarSettings();

  $(window).resize(function(e){
    setSidebarSettings();
  });
});


class TD_Events_Archive {

  constructor() {
    // Get dice.fm data from localized script
    this.allEvents = dicefmEvents;

    // Track elements in this.el
    this.trackElements();

    // Add Event Listeners
    this.loadMoreClickWatcher();
  }

  trackElements(){
    this.el = {};
    this.el.postWrap = document.querySelector('.events_posts');
    this.el.loadMore = document.querySelector('.events_posts__pagination button');
    
    this.setPostEls();
  }

  setPostEls() {
    this.el.posts = this.el.postWrap.querySelectorAll('.event_card');
    this.offset = this.el.posts.length;
  }

  loadMoreClickWatcher() {
    if(!!this.el.loadMore){
      this.el.loadMore.addEventListener('click', () => {
        this.perPage = parseInt(this.el.loadMore.getAttribute('data-per-page')); 
        this.el.loadMore.innerHTML = 'Loading...';
        this.loadMore();
      });
    }
  }

  getEventsBetweenIndexes(nodeArray, startIndex, endIndex) {
    if (!Array.isArray(nodeArray) || startIndex < 0 || startIndex >= endIndex) {
      return "Invalid input";
    }
    
    // If the endIndex is larger than the array length, 
    // set it to the last array index
    if(endIndex >= nodeArray.length) {
      endIndex = nodeArray.length;
    }

    return endIndex == startIndex ? [nodeArray[startIndex]] : nodeArray.slice(startIndex, endIndex);
  }


  loadMore() {
    const newCards = this.getEventsBetweenIndexes(this.allEvents, this.offset, (this.offset + this.perPage));
    this.addCards(newCards);
    this.setPostEls(); // reset post els now that new cards are loaded.

    // Set load more button to disabled if there are no more posts
    if(this.offset == this.allEvents.length){
      this.el.loadMore.innerHTML = 'All Events Loaded';
      this.el.loadMore.setAttribute('disabled', '');
    } 
    else {
      this.el.loadMore.innerHTML = 'Load More';
    }
  }

  addCards(eventsDataArray) {
    let lastStartDate = null;
    eventsDataArray.forEach((event) => {
      const node = event.node;
      
      // Build Card by cloning previous and updating content
      const cloneCard = this.el.posts[0].cloneNode(true);

      // Update ID
      cloneCard.setAttribute('id', 'event_' + node.id);
      cloneCard.setAttribute('data-event-id', node.id);

      // Update Image
      const image = cloneCard.querySelector('img');
      image.setAttribute('src', node.images[1].url);

      // Update Heading
      const heading = cloneCard.querySelector('h2');
      heading.innerHTML = node.name;

      // Update Date
      const dateEl = cloneCard.querySelector('.event_card__date_display.date .h4');
      const timeEl = cloneCard.querySelector('.event_card__date_display.time .h4');
      const startDate = this.formatDate(node.startDatetime);
      let startTime = this.formatDate(node.startDatetime, 'time');
      let endTime = this.formatDate(node.endDatetime, 'time');
      endTime = endTime.replace(' ', '');

      // Remove Duplicate am/pm in start/end times.
      if(startTime.includes('AM') && endTime.includes('AM')){
        startTime = startTime.replace(' AM', '');
      }
      else if(startTime.includes('PM') && endTime.includes('PM')){
        startTime = startTime.replace(' PM', '');
      }

      const time = startTime + '-' + endTime; 
      dateEl.innerHTML = startDate;
      timeEl.innerHTML = time;    
      
      // Update Links
      const links = cloneCard.querySelectorAll('a');
      console.log(event);
      const slug = this.slugifyTitle(event.node.name);
      links.forEach(link => {
        link.setAttribute('href', '/events/event?n='+slug+'&eid='+event.node.id);
      });

      // Add card to postsWrap
      this.el.postWrap.appendChild(cloneCard);

      // Track the last start date to add to the load more button
      lastStartDate = node.startDatetime;
    });

    // Update last start date on load more button
    this.el.loadMore.setAttribute('data-last-start-date', lastStartDate);
  }

  formatDate(dateString, returnVal = 'day') {
    const date = new Date(dateString);
    const options = {
      timeZone: 'America/New_York'
    };

    let formattedDay, formattedTime;

    if(returnVal == 'day'){
      const month = date.toLocaleString('en-US', { month: 'short' });
      const day = date.getDate();
      formattedDay = `${month} ${day}`;
    }
    else if(returnVal == 'time'){
      options.hour12 = true; // Display in 12-hour format
      options.hour = 'numeric';
      options.minute = 'numeric';
      formattedTime = date.toLocaleString('en-US', options);
    }

    return returnVal == 'day' ? formattedDay : formattedTime;
  }

  slugifyTitle(str) {
    return str.toLowerCase().replace(/[\s_]/g, '-').replace(/[^\w-]/g, '');
  }
}

$(document).ready(() => {
  if(document.body.classList.contains('post-type-archive-events')){
    document.body.eventsArchive = new TD_Events_Archive();
  }
});

